import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // retrieve JWT refresh token from local storage
  const token = localStorage.getItem('token');
  if (token) {
    const authReq = req.clone({
      // send refresh token in its header
      setHeaders: { 'x-refresh-token': token }
    });
    return next(authReq);
  }
  return next(req);
};